// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-align-center.icon{vertical-align:bottom}.select-state{position:relative;top:12px}.hideFooterSelect .v-data-footer__select{display:none}.hideFooterSelect .v-data-footer__pagination{margin:18px 32px 18px 24px}", ""]);
// Exports
module.exports = exports;
